export interface ScoreCalculator {
  Proxy: string
  Admin: string
  Implementation: string
}

export interface AddressObject {
  AgniPoolDeployer: string
  AgniFactory: string
  InitCodeHashAddress: string
  InitCodeHash: string
  WMNT: string
  SwapRouter: string
  Quoter: string
  QuoterV2: string
  TickLens: string
  NFTDescriptor: string
  NonfungibleTokenPositionDescriptor: string
  NonfungiblePositionManager: string
  AgniInterfaceMulticall: string
  MasterChef: string
  MasterChefV3Receiver: string
  AgniLmPoolDeployer: string
  ScoreCalculator: ScoreCalculator
  StakingPool: string
  IdoPoolTemplate: string
  IdoPoolFactory: string
  InsurancePool: string
  Multicall3: string
  tokens: string[]
  mixedRouteQuoterV1: string
  v2: {
    AgniFactory: string
    INIT_CODE_PAIR_HASH: string
    AgniRouter: string
    AgniFeeSetter: string
    AgniFeeTo: string
    WMNT: string
  }
}

// export const IS_QA = process.env.NEXT_PUBLIC_ENV === 'qa'

export const IS_PROD = process.env.NEXT_PUBLIC_ENV === 'main'

export const TESTNET_ADDRESSES: AddressObject = {
  AgniPoolDeployer: '0x6C53C6cC7c10B389c5680458Fc0C4079f3F012b4',
  AgniFactory: '0xA9AcD50B042A72c33d05fDcC8ad209d3aD361762',
  InitCodeHashAddress: '0xa18655b73FDC38665CFB9e09A5a0a10C14e68EC5',
  InitCodeHash: '0xaf9bd540c3449b723624376f906d8d3a0e6441ff18b847f05f4f85789ab64d9a',
  WMNT: '0x67A1f4A939b477A6b7c5BF94D97E45dE87E608eF',
  SwapRouter: '0xb5Dc27be0a565A4A80440f41c74137001920CB22',
  Quoter: '0xA82F8dC4704d3512b120de70480219761F24B6Eb',
  QuoterV2: '0x9Da17239a4170f50A5A2c11813BD0C601b5c9693',
  TickLens: '0xB4EB98c6d7D4807033Ae6195241ef7A839070748',
  NFTDescriptor: '0x7C20eE7CC3230003401cC19BF076871Aedf39856',
  NonfungibleTokenPositionDescriptor: '0x497bd1C86a1088e80f58EaA13de8C81aB70a4e79',
  NonfungiblePositionManager: '0x71959543c31EC4d68D9D6C492Bf69A1C174bb394',
  AgniInterfaceMulticall: '0x49b05721B9615dC1811E20F47D5700dA2d6Ed429',
  Multicall3: '0x521751C88EafdCAEd9cAbb4dB35a1400D6933428',
  mixedRouteQuoterV1: '0xE1E898d8C7519440d6F8c2B674642A9a617eD02c',
  tokens: [
    '0x67A1f4A939b477A6b7c5BF94D97E45dE87E608eF',
    '0xcc4ac915857532ada58d69493554c6d869932fe6',
    '0xacab8129e2ce587fd203fd770ec9ecafa2c88080',
    '0xf6762afb45ac0af7ddc5aa92b885c6ece57874dc',
    '0x3edb12e9cf43a6f645eedee2800e01e142c5758d',
  ],
  v2: {
    AgniFactory: '0x75F57C3a822cc37dd2453cAC3469a21361456BFb',
    AgniRouter: '0x3E30894AaEB2ba741b8E2999604D1d01fF6244ea',
    AgniFeeSetter: '0xB4ebe166513C578e33A8373f04339508bC7E8Cfb',
    AgniFeeTo: '0xB4ebe166513C578e33A8373f04339508bC7E8Cfb',
    WMNT: '0x67A1f4A939b477A6b7c5BF94D97E45dE87E608eF',
    INIT_CODE_PAIR_HASH: '0x32c0c6de30723d6476d34f01d79ce2df1df1a7ce4ea97ab3d9284b60dd59e540',
  },
} as AddressObject

export const MAINNET_ADDRESSES: AddressObject = {
  AgniPoolDeployer: '0xe9827B4EBeB9AE41FC57efDdDd79EDddC2EA4d03',
  AgniFactory: '0x25780dc8Fc3cfBD75F33bFDAB65e969b603b2035',
  InitCodeHashAddress: '0x5cfa0f1c4067C90a50B973e5F98CD265de5Df724',
  InitCodeHash: '0xaf9bd540c3449b723624376f906d8d3a0e6441ff18b847f05f4f85789ab64d9a',
  WMNT: '0x78c1b0C915c4FAA5FffA6CAbf0219DA63d7f4cb8',
  SwapRouter: '0x319B69888b0d11cEC22caA5034e25FfFBDc88421',
  Quoter: '0x9488C05a7b75a6FefdcAE4f11a33467bcBA60177',
  QuoterV2: '0xc4aaDc921E1cdb66c5300Bc158a313292923C0cb',
  TickLens: '0xEcDbA665AA209247CD334d0D037B913528a7bf67',
  NFTDescriptor: '0x70153a35c3005385b45c47cDcfc7197c1a22477a',
  NonfungibleTokenPositionDescriptor: '0xcb814b767D41b4BD94dA6Abb860D25b607ad5764',
  NonfungiblePositionManager: '0x218bf598D1453383e2F4AA7b14fFB9BfB102D637',
  AgniInterfaceMulticall: '0xBE592EFcF174b3E0E4208DC8c1658822d017568f',
  Multicall3: '0x05f3105fc9FC531712b2570f1C6E11dD4bCf7B3c',
  mixedRouteQuoterV1: '',
  tokens: [
    '0x78c1b0c915c4faa5fffa6cabf0219da63d7f4cb8',
    '0x201eba5cc46d216ce6dc03f6a759e8e766e956ae',
    '0xdeaddeaddeaddeaddeaddeaddeaddeaddead1111',
    '0x09bc4e0d864854c6afb6eb9a9cdf58ac190d0df9',
  ],
  v2: {
    AgniFactory: '0x75F57C3a822cc37dd2453cAC3469a21361456BFb',
    AgniRouter: '0x7Db468af451ac616588e5940a3d5cd48314629B1',
    AgniFeeSetter: '0xB4ebe166513C578e33A8373f04339508bC7E8Cfb',
    AgniFeeTo: '0xB4ebe166513C578e33A8373f04339508bC7E8Cfb',
    WMNT: '0x67A1f4A939b477A6b7c5BF94D97E45dE87E608eF',
    INIT_CODE_PAIR_HASH: '0x32c0c6de30723d6476d34f01d79ce2df1df1a7ce4ea97ab3d9284b60dd59e540',
  },
} as AddressObject

export const ADDRESSES = IS_PROD ? MAINNET_ADDRESSES : TESTNET_ADDRESSES

export const MAINNET_GRAPH_NODE_BASE_URL = 'https://www.perpstreet.xyz/graph/subgraphs/name'

export const TESTNET_GRAPH_NODE_BASE_URL = 'https://testnet.perpstreet.xyz/graph/subgraphs/name'

export const STAKE_TOKEN: string = IS_PROD ? '' : '0xf6762afb45ac0af7ddc5aa92b885c6ece57874dc'

export const MAINNET_GRAPH_NODE_EXCHANGE_SUBGRAPH_URL = `${MAINNET_GRAPH_NODE_BASE_URL}/agni/exchange-v3`
export const TESTNET_GRAPH_NODE_EXCHANGE_SUBGRAPH_URL = `${TESTNET_GRAPH_NODE_BASE_URL}/agni/exchange-v3`

export const MAINNET_GRAPH_NODE_EXCHANGE_V2_SUBGRAPH_URL = `${MAINNET_GRAPH_NODE_BASE_URL}/agni/exchange-v2`
export const TESTNET_GRAPH_NODE_EXCHANGE_V2_SUBGRAPH_URL = `${TESTNET_GRAPH_NODE_BASE_URL}/agni/exchange-v2`

export const GRAPH_NODE_EXCHANGE_SUBGRAPH_URL: string = IS_PROD
  ? MAINNET_GRAPH_NODE_EXCHANGE_SUBGRAPH_URL
  : TESTNET_GRAPH_NODE_EXCHANGE_SUBGRAPH_URL
export const GRAPH_NODE_BASE_URL: string = IS_PROD ? MAINNET_GRAPH_NODE_BASE_URL : TESTNET_GRAPH_NODE_BASE_URL
export const BASE_API_URL: string = IS_PROD ? 'https://www.perpstreet.xyz' : 'https://testnet.perpstreet.xyz'



export const mantle = {
  id: 43111,
  name: 'Hemi',
  network: 'eth',
  nativeCurrency: { decimals: 18, name: 'ETH', symbol: 'ETH' },
  rpcUrls: {
    default: { http: ['https://rpc.hemi.network/rpc'] },
    public: { http: ['https://rpc.hemi.network/rpc'] },
  },
  blockExplorers: {
    // etherscan: { name: 'MantleScan', url: 'https://explorer.hemi.xyz' },
    default: { name: 'Hemi Explorer', url: 'https://explorer.hemi.xyz' },
  },
  contracts: {
    multicall3: {
      address: MAINNET_ADDRESSES.Multicall3 as any,
      blockCreated: 3962,
    },
  },
}

export const mantleTestnet = {
  id: 743111,
  name: 'Hemi Testnet Network',
  network: 'eth',
  nativeCurrency: { decimals: 18, name: 'ETH', symbol: 'ETH' },
  rpcUrls: {
    default: { http: ['https://testnet.rpc.hemi.network/rpc'] },
    public: { http: ['https://testnet.rpc.hemi.network/rpc'] },
  },
  blockExplorers: {
    // etherscan: { name: 'MantleScan', url: 'https://explorer.hemi.xyz' },
    default: { name: 'Hemi Testnet Explorer', url: 'https://testnet.explorer.hemi.xyz' },
  },
  contracts: {
    multicall3: {
      address: TESTNET_ADDRESSES.Multicall3 as any,
      blockCreated: 4304523,
    },
  },
}
